/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormateurSuiviFichierGridDto
 */
export interface FormateurSuiviFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierGridDto
     */
    idformateurSuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierGridDto
     */
    idtypeSuiviFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof FormateurSuiviFichierGridDto
     */
    typeSuiviFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurSuiviFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurSuiviFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FormateurSuiviFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the FormateurSuiviFichierGridDto interface.
 */
export function instanceOfFormateurSuiviFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurSuiviFichierGridDtoFromJSON(json: any): FormateurSuiviFichierGridDto {
    return FormateurSuiviFichierGridDtoFromJSONTyped(json, false);
}

export function FormateurSuiviFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurSuiviFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateurSuiviFichier': !exists(json, 'idformateurSuiviFichier') ? undefined : json['idformateurSuiviFichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'typeSuiviFichier': !exists(json, 'typeSuiviFichier') ? undefined : json['typeSuiviFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function FormateurSuiviFichierGridDtoToJSON(value?: FormateurSuiviFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateurSuiviFichier': value.idformateurSuiviFichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'typeSuiviFichier': value.typeSuiviFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

